<template>
  <el-card>
    <app-breadcrumb :items="items"></app-breadcrumb>

    <app-table-paginate
      :key="reload"
      v-if="tableShow"
      routeDelete="no"
      selection="no"
      :tableQuery="getList"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="true"
      :noDisplayActions="true"
      :expand="true"
      :expandData="'history'"
      :expandColumns="expandColumns"
    ></app-table-paginate>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment-timezone";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";

export default {
  name: "historico-acceso-usuario",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb
  },
  created() {
    this.get();
    this.getUser();
  },
  data() {
    return {
      reload: 0,
      items: [
        {
          path: "/auditoria/",
          label: "Auditoría"
        },
        {
          path: "/auditoria/access-history",
          label: "Histórico de accesos"
        },
        {
          path: "/auditoria/access-history/user-history/",
          label: "Histórico acceso usuario"
        }
      ],
      user_id: this.$route.params.user_id,
      listAPI: false,
      strMonths: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      tableColumns: [
        {
          prop: "access_data",
          label: "Fecha"
        },
        {
          prop: "year",
          label: "Año"
        },
        {
          prop: "month",
          label: "Mes"
        },
        {
          prop: "ip",
          label: "IP"
        }
      ],
      expandColumns: [
        {
          prop: "acces_date",
          label: "Hora"
        },
        {
          prop: "page",
          label: "Página"
        },
        {
          prop: "path",
          label: "URL"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true
    };
  },
  methods: {
    async get() {
      ApiService.post("auditoria/user-history", {
        token: localStorage.getItem("token"),
        user_id: this.$route.params.user_id
      }).then(response => {
        if (response.data.length > 100) {
          // limito a 100 el historial
          response.data.length = 100;
        }

        this.listAPI = response.data;
        this.reload++;
        response.data.filter(e => {
          e.access_data = moment(e.access_data).format("DD-MM-YYYY");
          e.month = this.strMonths[e.month - 1];
          ApiService.post("auditoria/access-history-user", {
            token: localStorage.getItem("token"),
            id: e.id
          }).then(response => {
            e.history = response.data.filter(h => {
              h.acces_date = moment(h.acces_date).format("hh:mm a");
              return h;
            });
          });
          return e;
        });
      });
    },

    async getUser() {
      let data = {
        table: "users",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        relationship: [],
        id: this.$route.params.user_id,
        header: [
          {
            title: "Nombre",
            path: "name",
            type: "text",
            key: false,
            options: []
          },
          {
            title: "Apellido",
            path: "last_name",
            type: "text",
            key: false,
            options: []
          }
        ]
      };

      const response = await ApiService.post("dashboard/listtable", data);
      if (response) {
        this.items.push({
          path:
            "/auditoria/access-history/user-history/" +
            this.$route.params.user_id,
          label: response.data.name + " " + response.data.last_name
        });
      }
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date)
        .tz("Europe/Madrid")
        .format("DD/MM/YY");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auditoria/accesshistory/user.vue